/**
 * @param {"mounted" |"show" | 'never'} when
 */
export default (when = 'mounted') => {
  if (when === 'mounted') {
    return {
      mounted () {
        document.body.style.overflow = 'hidden';
      },
      beforeDestroy () {
        document.body.style.overflow = 'auto';
      }
    };
  } else if (when === 'show') {
    return {
      watch: {
        show () {
          if (this.show) {
            document.body.style.overflow = 'hidden';
          } else { document.body.style.overflow = 'auto'; }
        }
      }
    };
  } else if (when === 'never') {
    return {
      methods: {
        toggleScrolling (value) {
          if (value || this.show) {
            document.body.style.overflow = 'hidden';
          } else { document.body.style.overflow = 'auto'; }
        }
      }
    };
  }
};
